import { Flex } from '@chakra-ui/react'
import ReactConfetti from 'react-confetti'
import { IConfettiOptions } from 'react-confetti/dist/types/Confetti'

import useWindowSize from 'src/lib/hooks/useWindowSize'
import { colors } from 'src/theme/colors'

const hexFromChakraColor = (color: string) => {
  const [hue, brightness] = color.split('.')
  return brightness ? colors[hue][brightness] : colors[color]
}

const defaultColors = ['#66B3C9', '#CBAEDA', '#DF9772', '#94E2B6', '#FFD58D']

const Confetti = ({
  brandColor,
  confettiProps,
}: {
  brandColor?: string
  confettiProps?: IConfettiOptions
}) => {
  const { width, height } = useWindowSize()

  const brandedColors = [
    hexFromChakraColor(brandColor ? brandColor : 'brand.200'),
    hexFromChakraColor('sandstone'),
    hexFromChakraColor('vapor'),
    '#FFCF79',
    '#AAAAAA',
  ]

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex="toast"
      pointerEvents="none"
      data-testid="confettis-wrapper"
    >
      <ReactConfetti
        width={width}
        height={height}
        numberOfPieces={100}
        gravity={0.02}
        initialVelocityY={{ min: 0, max: 8 }}
        friction={0.99}
        recycle={false}
        tweenDuration={10000}
        colors={brandColor ? brandedColors : defaultColors}
        {...confettiProps}
      />
    </Flex>
  )
}

export default Confetti
